export default __webpack_public_path__ + "static/media/404.bd3a79b1.png";